<template>
    <div>
      <v-container>
    
       <v-row>
   
         <v-col cols="12">
                   <v-card elevation="1">
                  <v-toolbar elevation="0">
                    <v-icon left color="primary">mdi-account-details</v-icon> Collectibles As of <span class="font-weight-bold ml-2"> {{$moment().format('MMMM-YYYY')}}</span>
                    <v-spacer/>
                   
                  
                  </v-toolbar>
                  <v-card-text class="pa-0">
                   
                     <v-text-field
                               v-model="search"
                               append-icon="mdi-magnify"
                               label="Search Customer"
                               single-line
                               dense
                               outlined
                               hide-details
                           ></v-text-field>
                    <v-divider class="mt-4"/>
 <table class="va-table va-table-border-bot" >
                                      <!-- <tr>
                                        <th>Customers</th>
                                        <th>Collectibles</th>
                                       
                                      </tr>  -->
                                      <tr v-for="(item, index) in SEARCHFILTER" :key="index" :class="isDue(item.due_date, item.status)?'bg-warning-light':''">
                                        <td style="vertical-align: top;" class="text-center">
                                          <span class="font-weight-bold _link" @click="$router.push('/ledger-mobile/' + item.customer_id)">
                                          <v-icon left color="primary">mdi-account-details</v-icon>{{ FULLNAME(item.profile) }}
                                        </span>
                                          <br/> ID: {{item.customer_id}}
                                           <br/> Total Due: {{ $money(totalDue(item.payments)) }}
                                          <br/> Overdue Balance: {{ $money(totalOverDueBalance(item.payments)) }}
                                        </td>
                                        <td>
                                          <div  v-for="(payment, i) in item.payments" :key="i + '-lp'" >
                                           <span class="font-weight-bold">Due: {{ $moment(payment.due_date).format("MMM DD,  YYYY") }}</span>
                                           <br/>
                                           <span class="font-weight-bold">Amount: {{ $money(payment.amount) }}</span>
                                           <br />
                                          Paid: {{ $money(payment.paid_amount) }}
                                          <br/>
                                          Over Due balance: {{ $money(payment.balance) }}
                                          <br />
                                            <span :class="TEXT_COLOR(payment.status)" class="font-italic font-weight-bold">Status: {{ payment.status }}</span>
                                            <span v-if="payment.status == 'paid'" class="text-info font-italic def-font"> | {{ $moment(payment.payment_dt).format("MMM DD,  YYYY") }} </span>
                                            <v-divider class="mt-2 mb-2" v-if="i < item.payments.length - 1"/>
                                          </div>
                                        </td>
                                        
                                         
                                      </tr>
                                  </table>  
                  </v-card-text>
                 
             
                </v-card>
             </v-col>
       </v-row>
       </v-container>
        <!-- <va-customer-form :show="form" :selectedID="customer.id" :state="state" @DialogEvent="formEvent" />
         <va-customer-transaction :show="transaction" :customer="customer" @ConfirmEvent="transaction=false" /> -->
         <va-payment-form :show="form" :data="payment" :state="state" @DialogEvent="formEvent" />
          
     </div>
   </template>
   <script>
   import {
     mapMutations
   } from 'vuex'
     export default {
       data: () => ({
           form: false,
           tab: null,
           payment:{},
           transactions: [],
           payments:[],
           search:"",
           sales:{},
           state: 'new',
           user:{profile:{picture:""}},
           customer:{},
           userID:0
,           view: {
              per_page: 50,
              current_page: 1,
              pagination: true
           }
       }),
       beforeCreate: function () {
         if (!this.$session.exists()) {
           this.$router.push('/')
         }
       },
       created() {
          if (this.$session.exists()) {
             this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
             this.setLoggedIn(true) 
              this.CHECKPAGEPERMISSION()
             this.SETVARS()
             //this.userID= this.$IsNum(this.$route.params.id)
             setTimeout(()=>{this.getCollectibles()}, 500)
            
           }
       },
       computed:{
          COLLECTIBLES(){
            var items = []
            var groupBy = this.$groupBy('customer_id')
            var data = groupBy(this.payments)
            for (const [key, value] of Object.entries(data)) {
              console.log(key, value);
              items.push({ customer_id: key, profile: value[0].profile, payments: value })
            }
            return items
          },
           SEARCHFILTER(){
            if(this.search != "") {
              return this.$crawler(this.COLLECTIBLES, this.search)
            } else {
              return this.COLLECTIBLES
            }
         }
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn','setVariables']),
         isDue(due_date, status){
            var today = this.$moment()
            var _date = this.$moment(due_date)
            var overdue = _date.isBefore(today)
            if(status == 'pending' && overdue) {
                return true
            } return false
           
         },
          totalOverDueBalance(payments){
            var balance = 0
            payments.forEach((item)=>{
               
                 if(item.balance > 0) {
                    balance += item.balance
                }
            })
            return balance
          },
         totalDue(payments){
            var total = 0
            payments.forEach((item)=>{
                if(item.status == 'pending') {
                    total += item.amount
                }
               
            })
            return total
          },
          fullname(profile){
          if(profile.lastname == "") {
            return profile.firstname
          }
        
          return profile.lastname +', '+ profile.firstname
        },
       
        imagePreview(images){
          console.log("images",images)
         if(images == null) {
          return  this.$store.state.nopreview
         }
           if(images.length == 0) {
          return  this.$store.state.nopreview
         }
         let arr = this.ViewUploadedfiles(images)
         return arr[0]
        },
         formEvent(){
             this.form = false
             this.getCollectibles()
         },
        getTransactions() { 
         
            // this.transactions = []
            // this.QUERY('vendors',`select * from sales where customer_id=${this.userID} order by id desc`, (res)=>{
            //     if(res.status) {
            //         this.transactions = res.results
            //         this.getPayments()
            //     }
                
            // })
            this.getPayments()
        },
        getCollectibles() { 
           var _month = this.$moment().format("YYYY-MM")
            this.payments = []
            this.QUERY('vendors',`select p.*, c.profile from payment_schedules p left join customers c on c.id=p.customer_id
where (to_date(due_date,'YYYY-MM') <=  to_date('${_month}','YYYY-MM')) and (p.status='pending' or balance >0)`, (res)=>{
                if(res.status) {
                    this.payments = res.results
                      
                }
                
            })
        },   
       
       }
     }
   </script>